import { Box, IconButton, styled, useTheme } from "@mui/material";

import React from "react";

import { Fullscreen, Settings } from "@mui/icons-material";
import { GetData } from "contexts/DataContext";
import { openFullscreen } from "data/functions";
import { useNavigate } from "react-router-dom";
import { MainBody } from "./MainBody";

const Root = styled("div")(({ theme }) => ({
  background: "transparent",
  height: "100%",
  //https://colorgradient.dev/gradient-generator/
  // backgroundColor: grey[100],
  position: "relative",
}));

function MainPage(props) {
  const { dataObj } = GetData();
  const navigate = useNavigate();
  const theme = useTheme();
  return (
    <Root>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          position: "absolute",
          top: "2px",
          width: "100%",
          zIndex: "1200",
        }}
      >
        <IconButton onClick={() => navigate("settings")}>
          <Settings sx={{ fill: theme?.palette?.action?.selected }} />
        </IconButton>
        <IconButton onClick={() => openFullscreen()}>
          <Fullscreen sx={{ fill: theme?.palette?.action?.selected }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          height: "100%",
          justifyContent:
            dataObj?.payType === "self-service" ? "flex-start" : "center",
        }}
      >
        <MainBody />
      </Box>
    </Root>
  );
}

export default MainPage;
